<template>
  <div class="grid-x grid-margin-x">
    <div class="cell auto">
      <data-table
        icon="icon-menu-profile"
        :title="$t('metrics.assets_usage')"
        :headers="asset_headers"
        :items="assets"
      ></data-table>
    </div>
  </div>
</template>

<script>
import backend from '@/backend'

export default {
  name: 'MetricsAssetsUsage',
  data () {
    return {
      asset_headers: ['Paginas', 'Bekeken', 'Downloads', 'Shares'],
      assets: []
    }
  },
  created () {
    backend.get(`${process.env.VUE_APP_URL}/activity/assets`).then(response => {
      for (let i = 0; i <= response.data.length; i++) {
        const asset = {
          name: response.data[i].title,
          viewed: response.data[i].show_count,
          downloads: response.data[i].downloads_count,
          shares: response.data[i].shares_count
        }

        this.assets.push(asset)
      }
    })
  }
}
</script>

<style scoped></style>
